import React from 'react';

import { Wrapper } from './styles';

interface MarketplaceButtonProps {
    isListed: boolean;
    onBuyNow: () => void;
}

export const MarketplaceButton = ({ isListed, onBuyNow }: MarketplaceButtonProps) => {
    return (
        <Wrapper
            initial={{ opacity: 0, scale: 0.8, y: 20, x: '-50%' }}
            animate={{ opacity: 1, scale: 1, y: 0, x: '-50%' }}
            exit={{ opacity: 0, scale: 0.8, y: 20, x: '-50%' }}
            // TODO: Add make an offer function.
            onClick={isListed ? undefined : onBuyNow}
        >
            {isListed ? 'Make an offer' : 'Buy now'}
        </Wrapper>
    );
};
